import React from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { getClient } from '../../../../apollo/configuration';
import { localStateReducer } from '../../../../utils/common';
import TwoButtonFormModal, { TwoButtonFormModalProps } from './TwoButtonFormModal';

// eslint-disable-next-line
interface TwoButtonFormWithQueryModalProps<T> extends TwoButtonFormModalProps {
  onWiring?: (callback: (newState: { disabled: boolean }) => void) => void;
}

export default function TwoButtonFormWithQueryModal<T>(props: TwoButtonFormWithQueryModalProps<T>) {
  const [client] = React.useState(getClient());

  const [localState, setLocalState] = React.useReducer(localStateReducer, {
    disabled: props.disabled,
  });

  if (props.onWiring) {
    props.onWiring((newState) => {
      setLocalState({
        disabled: newState.disabled,
      });
    });
  }

  return (
    <TwoButtonFormModal
      {...props}
      body={<ApolloProvider client={client}>{props.body}</ApolloProvider>}
      disabled={localState.disabled}
    />
  );
}
